import { Menu, MenuProps as ChakraMenuProps } from '@chakra-ui/react'
import React from 'react'

interface DropdownProps extends ChakraMenuProps {
  children: JSX.Element[]
}

const Dropdown = (props: DropdownProps) => {
  const { children, ...otherProps } = props
  return <Menu {...otherProps}>{children}</Menu>
}

export default Dropdown
